export const extendNonSelectable = {
    overrides:{
        MUIDataTableHeadCell:{
            fixedHeader:{
                borderLeft: '1px solid #919e9f'
            }
        },
    }
}